import { GoogleMap, LoadScript, StreetViewPanorama } from "@react-google-maps/api";
import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { useAuthStore, useStreetViewStore } from "..";
import { useConditionallyClosable } from "../hooks/useClosable";
import { ClosableOrder } from "../store/ClosableStore";
import Modal from "./Modal";

function StreetView() {
    const authStore = useAuthStore();
    const streetViewStore = useStreetViewStore();
    const center = useMemo(() => computed(() => streetViewStore.coordinates && {
        lat: streetViewStore.coordinates.latitude,
        lng: streetViewStore.coordinates.longitude,
    }), []).get();

    const close = () => streetViewStore.clear();
    useConditionallyClosable(ClosableOrder.High, close, !!center);

    if (!center)
        return null;

    return (
        <Modal fullWidth onClose={close}>
            <LoadScript googleMapsApiKey={authStore.publicGoogleAccessToken!} libraries={["places"]}>
                <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={10}>
                    <StreetViewPanorama options={{
                        position: center,
                        visible: true,
                    }} />
                </GoogleMap>
            </LoadScript>
        </Modal>
    );
}

const containerStyle = {
    width: "100%",
    height: "650px",
};

export default observer(StreetView);